import * as actions from './actions'
import * as mutations from './mutations'
import getters from './getters'

const state = () => ({

})

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
